import React from "react";
import { Input } from "./";
import { makeStyles } from "@material-ui/styles";
import moment from "moment";

const useStyles = makeStyles({
  wrapper: {
    display: "flex",
  },
  dateWrapper: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
    justifyContent: "space-evenly",
  },
  input: {
    marginRight: 5,
    flex: "0 1 50%",
  },
  quick: {
    flex: "0 0 auto",
  },
  dateLabel: {
    // marginTop: 1,
    // marginLeft: 2,
    // fontSize: 10,
    // fontWeight: 600,
    // color: "#000",
    zIndex: 'revert-layer',

  },
  dateDropdown: {
    padding: 5,
    borderRadius: 5,
    border: 1,
    solid: "#ccc",
    marginRight: 5,
    marginTop: -3,
    marginLeft: -5,
  },
});

export default function DateRangePicker({
  onFromChange,
  from,
  onToChange,
  to,
  label,
  disabled,
}) {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.dateWrapper}>
        <Input
        label="Start Time - From"
          className={classes.dateDropdown}
          type="datetime-local"
          value={from}
          onChange={onFromChange}
          fullWidth
          disabled={disabled}
          clearable
          enableTooltip
          toolTipContent={
            from?
            moment(from).format('DD-MM-YYYY HH:mm') :''
          }
          InputLabelProps={{
            shrink: true,
          }}
          required></Input>
      </div>
      <div className={classes.dateWrapper}>
        <Input
        label="Start Time - To"
          className={classes.dateDropdown}
          type="datetime-local"
          value={to}
          onChange={onToChange}
          fullWidth
          disabled={disabled}
          clearable
          enableTooltip
          toolTipContent={
            to? moment(to).format('DD-MM-YYYY HH:mm'):''
          }
          InputLabelProps={{
            shrink: true,
            classes: {
              root: classes.dateLabel,  // Apply the dateLabel style here
            },
          }}
          required></Input>
      </div>
    </div>
  );
}
